import { render } from "./08_Footer.vue?vue&type=template&id=7b48f43e&scoped=true"
import script from "./08_Footer.vue?vue&type=script&lang=js"
export * from "./08_Footer.vue?vue&type=script&lang=js"

import "./08_Footer.vue?vue&type=style&index=0&id=7b48f43e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b48f43e"]])

export default __exports__